<template>
  <section class="auth wrapper__bg">
    <div class="container">
      <div class="auth__content">
        <div class="auth__colform">
          <div class="auth__nav">
            <a href="https://relaxstation-club.com" class="auth__logo">
              <img src="@/assets/images/logo.svg" alt="" />
            </a>
            <h1 class="auth__caption">
              {{ $t("auth.registration") }}
            </h1>
          </div>

          <form
            v-if="!isRegistered"
            class="form"
            @submit.prevent="handleSubmit(!v$.$invalid)"
            novalidate
          >
            <div class="form__item">
              <input
                type="text"
                v-model="form.username"
                required=""
                :class="getInputClass(v$.form.username)"
                class="form__input"
              />
              <label for="" class="form__label">{{ $t("auth.login") }}</label>
              <validate-error
                :field="v$.form.username"
                :submitted="submitted"
              />
            </div>

            <div class="form__item">
              <input
                type="text"
                required=""
                v-model="form.email"
                :class="getInputClass(v$.form.email)"
                class="form__input"
              />
              <label for="" class="form__label">Email</label>
              <validate-error :field="v$.form.email" :submitted="submitted" />
            </div>

            <div class="form__item">
              <input
                type="password"
                required=""
                v-model="form.plainPassword.first"
                :class="getInputClass(v$.form.plainPassword.first)"
                class="form__input"
              />
              <label for="" class="form__label">
                {{ $t("auth.password") }}
              </label>
              <validate-error
                :field="v$.form.plainPassword.first"
                :submitted="submitted"
              />
            </div>

            <div class="form__item">
              <input
                required=""
                type="password"
                v-model="form.plainPassword.second"
                :class="getInputClass(v$.form.plainPassword.second)"
                class="form__input"
              />
              <label for="" class="form__label">
                {{ $t("auth.password_repeat") }}
              </label>
              <validate-error
                :field="v$.form.plainPassword.second"
                :submitted="submitted"
              />
            </div>

            <div class="form__item">
              <label class="checkbox" :class="getInputClass(v$.form.rules)">
                <span class="checkbox-txt">
                  {{ $t("auth.i_have_familiarized_with") }}
                  <a
                    :href="
                      'https://relaxstation-club.com/' +
                      this.$i18n.locale +
                      '/pages/terms-of-use'
                    "
                    class="checkbox-link"
                    target="_blank"
                  >
                    {{ $t("auth.terms_of_use") }}
                  </a>
                  {{ $t("common.and") }}
                  <a
                    :href="
                      'https://relaxstation-club.com/' +
                      this.$i18n.locale +
                      '/pages/privacy-policy'
                    "
                    class="checkbox-link"
                    target="_blank"
                  >
                    {{ $t("auth.privacy_policy") }}
                  </a>
                </span>
                <input
                  v-model="form.rules"
                  type="checkbox"
                  class="form-check-input"
                  :class="getInputClass(v$.form.rules)"
                  id="rules"
                />

                <span class="checkbox-checkmark"></span>
              </label>
            </div>

            <button class="btn-link" type="submit">
              <span class="text">{{ $t("auth.go_to_register") }}</span>
              <span class="form__btn">
                <svg>
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <span class="btn-arrow"
                  ><img src="@/assets/images/auth/icon/arrow-gold.svg" alt=""
                /></span>
              </span>
            </button>
            <div class="form__other">
              <span class="form__other-span">
                {{ $t("auth.have_an_account") }}
              </span>

              <router-link class="gold" :to="{ name: 'login' }">
                {{ $t("auth.log_in") }}
              </router-link>
            </div>
          </form>

          <div class="wrong-token" v-if="isRegistered">
            {{ $t("auth.email_was_sent_for_confirmation") }}
            {{ $t("auth.go_to_link_for_activation") }}

            <div class="form__other">
              <span class="form__other-span">
                {{ $t("auth.have_an_account") }}
              </span>

              <router-link class="gold" :to="{ name: 'login' }">
                {{ $t("auth.log_in") }}
              </router-link>
            </div>
          </div>
        </div>

        <AuthSlider />
      </div>
    </div>
  </section>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
  alphaNum,
} from "@/utils/i18n-validators";
import { mapActions, mapGetters } from "vuex";
import AuthSlider from "@/components/profile/AuthSlider";
import ValidateError from "@/components/dumb-components/validateError";

export default {
  name: "RegisterPage",
  components: {
    ValidateError,
    AuthSlider,
  },
  setup: () => ({ v$: useVuelidate({ $autoDirty: true }) }),
  data: () => ({
    isRegistered: false,
    submitted: false,
    vuelidateExternalResults: [],
    form: {
      username: "",
      email: "",
      plainPassword: {
        first: "",
        second: "",
      },
      rules: false,
      referral: "",
    },
  }),
  validations() {
    return {
      form: {
        username: {
          required,
          alphaNum,
          minLength: minLength(6),
          maxLength: maxLength(20),
        },
        email: { required, email },
        plainPassword: {
          first: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(20),
          },
          second: {
            required,
            sameAs: sameAs(this.form.plainPassword.first),
          },
        },
        rules: {
          checked: (val) => {
            return val;
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
    }),
    langParam() {
      return this.$route.query._locale;
    },
  },
  methods: {
    ...mapActions({
      register: "auth/register",
    }),
    handleSubmit(isFormValid) {
      this.submitted = true;

      if (!isFormValid) {
        return;
      }

      this.register(this.form).then(
        () => {
          this.isRegistered = true;
          // this.$router.push({ name: "academy" });
        },
        (fail) => {
          this.isRegistered = false;
          Object.assign(this.vuelidateExternalResults, { form: fail.errors });
        }
      );
    },
    getInputClass(field) {
      return field.$invalid && this.submitted ? "invalid" : "";
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);

      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return null;
    },
  },
  created() {
    if (this.isAuthenticated) {
      this.$router.push("/");
    }

    if (this.getCookie("referral_user")) {
      this.form.referral = this.getCookie("referral_user");
    }

    console.log(this.form.referral);

    if (this.langParam) {
      this.$i18n.locale = this.langParam;
      localStorage.setItem("lang", this.langParam);
    }
  },
};
</script>

<style scoped lang="scss">
.invalid-feedback {
  display: inherit;
  color: #ff7b7b;
  margin-top: -25px;
  position: absolute;
  font-size: 14px;
}

.form {
  .messenger {
    display: flex;

    .select__item {
      padding-right: 30px;
      width: 200px;

      select {
        height: 40px;
        //background: linear-gradient(148.72deg, #1a4968 4.58%, #245575 83.92%);
      }
    }

    .select__item__value {
      width: 100%;
    }
  }

  .checkbox.invalid {
    .checkbox-checkmark {
      border-color: rgb(255, 123, 123);
    }
    .checkbox-txt {
      color: rgb(255, 123, 123);
      a {
        color: rgb(255, 123, 123);
      }
    }
  }
}

.form-error-message {
  margin-bottom: 20px;
  color: #ff7b7b;
}
.auth__logo {
  img {
    width: 250px;
  }
}
.wrong-token {
  color: #fff;
}
</style>
